import { Dayjs } from "dayjs";
import { Biobox, Compliance } from "../../../types";
import { SporetestLogAction } from "./enums";

export enum BioboxFilters {
  Active = 0,
  UpToDate = 1,
  AttentionNeeded = 2,
  Expired = 3,
  Inactive = 4,
}

export enum StatusFilters {
  Active = 'All Active',
  UpToDate = 'Up to Date',
  AttentionNeeded = 'Attention Needed',
  Expired = 'Expired',
}

export interface Autoclave {
  active: boolean;
  autoclave_brand: string | null;
  autoclave_frequency: number;
  autoclave_id: number;
  autoclave_location: string | null;
  autoclave_model: string | null;
  autoclave_name: string;
  autoclave_serial: string;
  autoclavetype_id: string | number | null;
  autoclave_compliance: AutoclaveCompliance;
  customer_number: string;
  deleted: boolean;
  autoclave_confirmation?: AutoclaveConfirmation | null;
  bioboxes?: VwBiobox[];
}

export interface VwBiobox {
  box_id: string;
  item_number: string;
  lot_number: string;
  box_number: string | number;
  active: boolean;
  city: string;
  state: string;
  compliance_code: string;
  compliance_status: number;
  message_short: string;
  message_long: string;
  priority: number;
  exp_date: string;
  box_size: number;
  tests_run: number;
  purchase_date: string;
  customer_number: string;
  parent_customer_number: string;
  name: string;
  created_date: string;
  updated_date: string;
  autoclave_id: number;
  box_type: string;
}

interface AutoclaveConfirmation {
  updated_date?: string | null;
  updated_by_user?: number | string | null;
}

export interface AutoclaveType {
  autoclavetype_id: number;
  autoclavetype_name: string;
}

interface AutoclaveCompliance {
  autoclave_id: number;
  compliance: Compliance;
  compliance_code: string;
}

export interface Frequency {
  frequency_description: string;
  key_: number;
}

export interface SporetestingResult {
  addressed_on: string | null;
  autoclave_id: number;
  box_id: string | null;
  customer_id: string;
  note: string | null;
  received_date: string | null;
  result_description: string;
  sample_date: string | null;
  test_date: string;
  test_number: string | null;
  test_operator: string | null;
  test_result: string | null;
  test_result_id: number | string;
  test_type: string;
}

export interface BioboxCompliance {
  compliance_code: string,
  compliance_message_long: string,
  compliance_message_short: string,
  compliance_status: number,
}

export interface FormattedBiobox {
  box_id: number,
  box_number: string,
  box_size: number,
  active: boolean,
  activeStatus: 'active' | 'inactive',
  exp_date: string,
  item_number: string,
  lot_number: string,
  tests_run: number,
  purchase_date: string,
  city: string,
  doctor_name: string,
  customer_number: string,
  name: string,
  state: string,
  created_date: string,
  updated_date: string,
  autoclave_id: number | null,
  box_type: string,
  compliance: BioboxCompliance[],
}

export interface StatusFilterOption {
  label: StatusFilters,
  status: BioboxFilters,
}

export interface OpenBioboxAlert {
  open: boolean,
  type: 'success' | 'error' | null,
  message: string,
}

export type OpenAssignBoxModal = {
  open: boolean,
  autoclave: Autoclave | null,
  biobox: FormattedBiobox | Biobox | null,
}

export type OpenAutoclaveModal = {
  open: boolean,
  autoclave: Autoclave | null,
}

export type OpenSporetestModal = {
  open: boolean,
  autoclaveId: number | null,
  testType: string,
  sporetest: SporetestingResult | null,
}

export type TestKit = { kitId: string, sterilizationMethod: string }

export type ValidationField = 'autoclave_name' | 'autoclave_brand' | 'autoclave_model' | 'autoclave_serial'

export type AddEditAutoclaveErrors = {
  autoclave_name: {
    isValid: boolean,
    message: string | null,
  },
  autoclave_serial: {
    isValid: boolean,
    message: string | null,
  },
  autoclave_brand: {
    isValid: boolean,
    message: string | null,
  },
  autoclave_model: {
    isValid: boolean,
    message: string | null,
  },  
}

export type SporetestLog = {
  id?: number,
  customer_number: string,
  login_user_id?: number,
  autoclave_id: number | null,
  box_id: number,
  test_result_id: number,
  sample_date: string,
  test_operator: string,  
  action: SporetestLogAction,
  created_at?: string,
}

export type SporetestLogRow = {
  id: number,
  box_number: string,
  test_number: string,
  sample_date: Dayjs,
  test_operator: string,
  created_at: Dayjs,
  user_name: string, 
  action: SporetestLogAction,
}

